<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="todo__filters-container">

        <!-- all 
        <div class="px-6 py-4">
            <router-link tag="span" class="flex cursor-pointer" :class="{'text-primary': todoFilter == 'all'}" :to="`${baseUrl}/all`">
                <feather-icon icon="LayersIcon" :svgClasses="[{'text-primary stroke-current': todoFilter == 'all'}, 'h-6 w-6']"></feather-icon>
                <span class="text-lg ml-3">All</span>
            </router-link>
        </div>-->
        <!-- classe-->
        <div class="px-5 py-4 mt-5 ml-5">
          <h5><span class="text-white bg-primary op-block">{{this.$store.state.classe.users[0].titre}} Groupe {{this.$store.state.classe.users[0].numero}}</span></h5>
        </div>
        <vs-divider></vs-divider>
        
        <!-- starred -->
        
        <!-- starred -->
        <div class="px-6 py-4">
            <h5>Seance restand</h5>
            <template v-for="filter in $store.state.classe.seances"> 
                 <div :key="filter.id" v-if="filter.date >= dateNew"> 
                <router-link tag="span" class="flex mt-6 cursor-pointer" :class="{'text-primary': todoFilter == filter.id}" :to="`${baseUrl}/${$route.params.userId}/${filter.id}`" :key="filter.id">
                    <feather-icon icon='PlusCircleIcon' :svgClasses="[{'text-primary stroke-current': todoFilter == filter.id}, 'h-6 w-6']"></feather-icon>
                    <span class="text-lg ml-3">{{ filter.date }}</span>
                </router-link>
            </div>    
            </template>
            
        </div>
        <div class="px-6 py-1"><vs-divider></vs-divider></div>
        <div class="px-6 py-4">
            <h5>historique</h5>
            <template v-for="filter in $store.state.classe.seances">
              <div :key="filter.id" v-if="filter.date < dateNew">
                <router-link tag="span" class="flex mt-6 cursor-pointer" :class="{'text-primary': todoFilter == filter.id}" :to="`${baseUrl}/${$route.params.userId}/${filter.id}`" :key="filter.id">
                    <feather-icon icon='CheckIcon' :svgClasses="[{'text-primary stroke-current': todoFilter == filter.id}, 'h-6 w-6']"></feather-icon>
                    <span class="text-lg ml-3">{{ filter.date }}</span>
                </router-link>
              </div> 
            </template>
            
        </div>
        <vs-divider></vs-divider>

        

    </div>
</template>
<script>
import moduleclasse from '@/store/classe/moduleclasse.js'
import vSelect from 'vue-select'

export default {
  data() {
        return {
          dateNew: new Date().toISOString().slice(0,10),
            todoFilters: [
                
            ],
            //classe_data:null
        }
    },
    components: {
    vSelect
  },
  computed: {
    
        todoFilter() {
            return this.$route.params.seanceId
        },
        baseUrl() {
          const path = this.$route.path
         // console.log('this.$route.path1',path.slice(0, path.lastIndexOf("/")))
          const pathh = path.slice(0, path.lastIndexOf("/"))
          //console.log('this.$route.path2',pathh.slice(0, path.lastIndexOf("/")))
          return path.slice(0, pathh.lastIndexOf("/")).slice(0, path.lastIndexOf("/"))
          //const path = this.$route.path
          //return path.slice(0, path.lastIndexOf("/"))
        },
        
    },
  methods: {
    
    },
  created() {
    // Register Module UserManagement Module
    console.log('1200000',this.$route.params.userId)
    if(!moduleclasse.isRegistered) {
      this.$store.registerModule('classe', moduleclasse)
      moduleclasse.isRegistered = true
    }
    
    this.$store.dispatch("classe/fetchSeances",this.$route.params.userId).catch(err => { console.error(err) })
    this.$store.dispatch("classe/fetchClassesID",this.$route.params.userId).catch(err => { console.error(err) })
    console.log('seance',this.$store.state.classe.groupes)
    console.log('classe',this.$store.state.classe.users)
    console.log('37',this.$store.state.classe.users)
    console.log('37',this.$store.state.classe.users)
    ///this.$store.dispatch("classe/fetchSeances",this.$store.state.classe.users[0].id).catch(err => { console.error(err) })     
     //let filter = this.$route.params.filter
     //console.log('370',filter) 
    },
}

</script>
